export interface ViewportMetrics {
  standalone: boolean
  screenWidth: number
  screenHeight: number
  innerWidth: number
  innerHeight: number
}

export const MAX_VIEWPORT_BOTTOM_GAP_PX = 120

export function measureViewportBottomGap(m: ViewportMetrics): number {
  if (!m.standalone) {
    return 0
  }
  const isPortrait = m.innerHeight >= m.innerWidth
  const expected = isPortrait
    ? Math.max(m.screenWidth, m.screenHeight)
    : Math.min(m.screenWidth, m.screenHeight)
  const gap = Math.max(0, Math.round(expected - m.innerHeight))
  if (gap > MAX_VIEWPORT_BOTTOM_GAP_PX) {
    return 0
  }
  return gap
}

export function readViewportMetrics(): ViewportMetrics {
  const nav = typeof window !== 'undefined' ? (window.navigator as { standalone?: boolean } | undefined) : undefined
  const scr = typeof window !== 'undefined' ? window.screen : undefined
  const innerW = typeof innerWidth !== 'undefined'
    ? innerWidth
    : (typeof window !== 'undefined' ? window.innerWidth : 0)
  const innerH = typeof innerHeight !== 'undefined'
    ? innerHeight
    : (typeof window !== 'undefined' ? window.innerHeight : 0)

  return {
    standalone: nav?.standalone === true,
    screenWidth: scr?.width ?? 0,
    screenHeight: scr?.height ?? 0,
    innerWidth: innerW,
    innerHeight: innerH,
  }
}
